import { render, staticRenderFns } from "./CreateTraderScreen.vue?vue&type=template&id=1a13a1ec&scoped=true"
import script from "./CreateTraderScreen.vue?vue&type=script&lang=ts"
export * from "./CreateTraderScreen.vue?vue&type=script&lang=ts"
import style0 from "./CreateTraderScreen.vue?vue&type=style&index=0&id=1a13a1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13a1ec",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QForm,QItem,QItemSection,QAvatar,QImg,QIcon,QInput,QSelect});
